// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"482":"charts","824":"portfolio"}[chunkId] || chunkId) + "." + {"74":"02d57fa8","128":"17d99456","134":"3b074a91","180":"e4da614e","329":"f6c2ef21","479":"5052ad5c","482":"51ab6a03","550":"e9e60f59","761":"78239dc7","819":"00ff12ec","824":"a808b4cd","904":"42e5e41f","927":"8b17cc39","951":"70a52edd"}[chunkId] + ".js";
};